"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCryptoTable = void 0;
const formatCryptoTable = (declarationParameters, translationsKeys) => {
    var _a, _b, _c, _d, _e, _f;
    const withSeparator = true;
    const withCopy = true;
    const withBottomPad = true;
    const withTopPad = true;
    const { cryptoTableDepositAmount, cryptoTableTransactionFee, cryptoTableCryptoAmount, cryptoTableFixedRate, cryptoTableNetwork, cryptoTablePaymentAmount, cryptoTablePayToWallet, cryptoDestinationTagText, cryptoDestinationMemoText } = translationsKeys;
    const { depositAmount, transactionFee, cryptoAmount, fixedRate, paymentAmount, wallet, } = declarationParameters;
    const destination = (wallet === null || wallet === void 0 ? void 0 : wallet.tag) || (wallet === null || wallet === void 0 ? void 0 : wallet.memo) ? {
        label: (wallet === null || wallet === void 0 ? void 0 : wallet.tag) ? cryptoDestinationTagText : cryptoDestinationMemoText,
        value: (wallet === null || wallet === void 0 ? void 0 : wallet.tag) || (wallet === null || wallet === void 0 ? void 0 : wallet.memo),
        withCopy,
        className: "align-top"
    } : {};
    return [
        {
            label: cryptoTableDepositAmount,
            value: `${depositAmount === null || depositAmount === void 0 ? void 0 : depositAmount.amount} ${(_a = depositAmount === null || depositAmount === void 0 ? void 0 : depositAmount.currency) === null || _a === void 0 ? void 0 : _a.toUpperCase()}`
        },
        {
            label: cryptoTableTransactionFee,
            value: `${transactionFee === null || transactionFee === void 0 ? void 0 : transactionFee.amount} ${(_b = transactionFee === null || transactionFee === void 0 ? void 0 : transactionFee.currency) === null || _b === void 0 ? void 0 : _b.toUpperCase()}`
        },
        {
            label: cryptoTableCryptoAmount,
            value: `${cryptoAmount === null || cryptoAmount === void 0 ? void 0 : cryptoAmount.amount} ${(_c = cryptoAmount === null || cryptoAmount === void 0 ? void 0 : cryptoAmount.currency) === null || _c === void 0 ? void 0 : _c.toUpperCase()}`
        },
        {
            label: cryptoTableFixedRate,
            value: `1 ${(_d = fixedRate === null || fixedRate === void 0 ? void 0 : fixedRate.cryptoCurrency) === null || _d === void 0 ? void 0 : _d.toUpperCase()} = ${fixedRate === null || fixedRate === void 0 ? void 0 : fixedRate.rate} ${(_e = fixedRate === null || fixedRate === void 0 ? void 0 : fixedRate.fiatCurrency) === null || _e === void 0 ? void 0 : _e.toUpperCase()}`
        },
        {
            label: cryptoTableNetwork,
            value: wallet === null || wallet === void 0 ? void 0 : wallet.network,
            withSeparator,
            withBottomPad
        },
        {
            label: cryptoTablePaymentAmount,
            value: `${paymentAmount === null || paymentAmount === void 0 ? void 0 : paymentAmount.amount} ${(_f = paymentAmount === null || paymentAmount === void 0 ? void 0 : paymentAmount.currency) === null || _f === void 0 ? void 0 : _f.toUpperCase()}`,
            valueToCopy: paymentAmount === null || paymentAmount === void 0 ? void 0 : paymentAmount.amount,
            withCopy,
            withSeparator,
            withBottomPad,
            withTopPad
        },
        {
            label: cryptoTablePayToWallet,
            value: wallet === null || wallet === void 0 ? void 0 : wallet.address,
            withCopy,
            withTopPad,
            className: "align-top"
        },
        Object.assign({}, destination),
        {
            label: "",
            value: "",
            qrCodeUri: wallet === null || wallet === void 0 ? void 0 : wallet.uri,
            withBottomPad
        }
    ];
};
exports.formatCryptoTable = formatCryptoTable;
